import { render } from "./SelectTeacher.vue?vue&type=template&id=a1137ac6&scoped=true"
import script from "./SelectTeacher.vue?vue&type=script&lang=js"
export * from "./SelectTeacher.vue?vue&type=script&lang=js"

import "./SelectTeacher.vue?vue&type=style&index=0&id=a1137ac6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1137ac6"]])

export default __exports__